__turbopack_context__.v({
  "animatedDialog": "eTnzua_animatedDialog",
  "fadeIn": "eTnzua_fadeIn",
  "fadeOut": "eTnzua_fadeOut",
  "scaleDown": "eTnzua_scaleDown",
  "scaleUp": "eTnzua_scaleUp",
});
